import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChlastLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80c13",
			d: "M 30,22 L 44,22 L 52,35.6 L 7.62,35.6 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ececec",
			d: "M 29,4 L 44,22 L 30,22 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#08437f",
			d: "M 29,4 L 30,22 L 7.62,35.6 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ececec",
			d: "M 21,40 L 21,36 A 6,6 0 0 1 30,31.5 A 7,7 0 0 1 42,33 A 5.5,5.5 0 0 1 46,40 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9cc0c",
			d: "M 21,40 L 46,40 L 34,54 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#08437f",
			d: "M 34,61 L 55,39 L 46,39 L 34,53 L 21,39 L 13,39 Z"
		})
	]
});
export default SvgChlastLogo;
